import { render } from "./favorites.vue?vue&type=template&id=b49df7a2"
import script from "./favorites.vue?vue&type=script&lang=js"
export * from "./favorites.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__